import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & {
	modalSizePresets: string
	modalSizeUnits: string
	modalHeader: boolean
	modalTitle: string
	modalTitleOrder: string
	modalOpacity: number
	modalBlur: number
	closeAction: boolean
	centered: boolean
	modalOffset: boolean
}

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'open', displayName: 'Open', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'close', displayName: 'Close', group: 'Signals', type: 'signal' }),
			getPortDef({
				name: 'trapFocus',
				displayName: 'Trap focus',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({
				name: 'returnFocus',
				displayName: 'Return focus',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),

			getPortDef({
				name: 'closeOnEscape',
				displayName: 'Close on escape',
				group: 'Params',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'closeOnClickOutside',
				displayName: 'Close on click outside',
				group: 'Params',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'centered',
				displayName: 'Centered',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({ name: 'modalSizePresets', displayName: 'Size', group: 'Dimensions', type: sizes, default: 'sm' }),
			getPortDef({
				name: 'modalSizeUnits',
				displayName: 'Size units',
				group: 'Dimensions',
				type: 'string',
				default: '',
				tooltip: '100vw, 100%, 500px, 20rem, auto'
			}),
			getPortDef({
				name: 'modalOffset',
				displayName: 'Offset',
				group: 'Custom',
				customGroup: 'Offset',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'yOffset',
				displayName: 'Vertical offset',
				group: 'Custom',
				customGroup: 'Offset',
				type: 'string',
				dependsOn: (p: Props) => p.modalOffset,
				tooltip: '1vh, 20%, 100px, 100'
			}),
			getPortDef({
				name: 'xOffset',
				displayName: 'Horizontal offset',
				group: 'Custom',
				customGroup: 'Offset',
				type: 'string',
				dependsOn: (p: Props) => p.modalOffset,
				tooltip: '1vh, 20%, 100px, 100'
			}),
			getPortDef({
				name: 'modalHeader',
				displayName: 'Header',
				group: 'Custom',
				customGroup: 'Header',
				type: 'boolean',
				default: false,
			}),
			getPortDef({
				name: 'modalTitle',
				displayName: 'Title',
				group: 'Custom',
				customGroup: 'Header',
				type: 'string',
				dependsOn: (p: Props) => p.modalHeader,
			}),
			getPortDef({
				name: 'modalTitleOrder',
				displayName: 'Title Order',
				group: 'Custom',
				customGroup: 'Header',
				type: [
					{ label: 'H1', value: '1' },
					{ label: 'H2', value: '2' },
					{ label: 'H3', value: '3' },
					{ label: 'H4', value: '4' },
					{ label: 'H5', value: '5' },
					{ label: 'H6', value: '6' },
				],
				default: '3',
				dependsOn: (p: Props) => p.modalHeader,
			}),
			getPortDef({
				name: 'closeAction',
				displayName: 'Close action',
				group: 'Custom',
				customGroup: 'Header',
				type: 'boolean',
				default: false,
				dependsOn: (p: Props) => p.modalHeader,
			}),
			getPortDef({
				name: 'modalOpacity',
				displayName: 'Opacity',
				group: 'Styles',
				type: 'number',
				default: 0.6,
			}),
			getPortDef({
				name: 'modalBlur',
				displayName: 'Blur',
				group: 'Styles',
				type: 'number',
				default: 2,
			}),
			getPortDef({
				name: 'fullScreen',
				displayName: 'Full Screen',
				group: 'Layout',
				type: 'boolean',
				default: false,
			}),
		],

		outputs: [getPortDef({ name: 'closed', displayName: 'Сlosed', group: 'Signals', type: 'signal' })],
	},
} satisfies ReactNodeDef
